import { CollapsableMenuProps } from '../components/CollapsableMenu'
import { PATH_SELECTOR_ICONS } from './icons'
import { SUBSCRIPTIONS_PAGE_PATH } from '@cannect/services/resources/recurrency/constants'
import { SHARED_OPTIONS_DESCRIPTIONS, SIDE_PANEL_MY_ORDERS, SIDE_PANEL_MY_TICKETS } from './shared'

const OPTIONS_LIST = {
  profile: [
    {
      title: 'Dados pessoais',
      to: '/conta?pagina=perfil-dados-pessoais',
      enabled: true
    },
    {
      title: 'Alterar senha',
      to: '/conta?pagina=perfil-alterar-senha',
      enabled: true
    },
    {
      title: 'Autenticação em duas etapas',
      to: '/conta?pagina=perfil-2fa',
      enabled: true
    },
    {
      title: 'Documentos',
      to: '/conta?pagina=perfil-documentos',
      enabled: false
    },
    {
      title: 'Receitas',
      to: '/conta?pagina=perfil-receitas',
      enabled: false
    },
    {
      title: 'Comprovantes',
      to: '/conta?pagina=perfil-comprovantes',
      enabled: true
    }
  ],
  addresses: [
    {
      title: 'Endereço de entrega',
      to: '/conta?pagina=enderecos-entrega',
      enabled: true
    },
    {
      title: 'Endereço de cobrança',
      to: '/conta?pagina=enderecos-cobranca',
      enabled: true
    }
  ]
}

export const PATIENT_SIDE_PANEL: CollapsableMenuProps[] = [
  {
    title: {
      label: 'Meu perfil',
      subItemsId: 'perfil',
      icon: PATH_SELECTOR_ICONS.profile,
      enabled: true
    },
    subItems: OPTIONS_LIST.profile
  },
  // {
  //   title: {
  //     label: 'Endereços',
  //     subItemsId: 'enderecos',
  //     icon: PATH_SELECTOR_ICONS.address,
  //     enabled: true
  //   },
  //   subItems: OPTIONS_LIST.addresses
  // },
  SIDE_PANEL_MY_ORDERS,
  SIDE_PANEL_MY_TICKETS,
  {
    title: {
      label: 'Meus cartões',
      to: '/conta?pagina=cartoes',
      icon: PATH_SELECTOR_ICONS.card,
      enabled: false
    }
  },
  {
    title: {
      label: 'Minhas consultas',
      to: '/conta?pagina=consultas',
      icon: PATH_SELECTOR_ICONS.consult,
      enabled: true
    }
  }
  /* SIDE_PANEL_HELP */
]

// "Minhas assinaturas" (008): fora do array estático; entra pelo
// `usePatientSidePanel` só para quem tem ou teve assinatura.
export const SIDE_PANEL_MY_SUBSCRIPTIONS: CollapsableMenuProps = {
  title: {
    label: 'Minhas assinaturas',
    icon: PATH_SELECTOR_ICONS.subscription,
    enabled: true,
    to: SUBSCRIPTIONS_PAGE_PATH
  }
}

export const PATIENT_LINKS_DESCRIPTIONS = {
  'Minhas assinaturas': 'Veja, ajuste, pule ou pause suas entregas automáticas',
  'Meu perfil':
    'Altere ou consulte seus dados de acesso, dados pessoais, documentos, receitas e comprovantes de pagamento',
  Endereços: 'Altere endereços cadastrados para entrega de pedidos e cobrança de faturas',
  'Meus cartões': 'Altere, consulte ou remova seus cartões cadastrados',
  'Minhas consultas': 'Verifique sua agenda de consultas',
  ...SHARED_OPTIONS_DESCRIPTIONS
}
